import * as React from 'react';

import InfusionChoicePaneStore from '../InfusionChoicePaneStore';
import withAvailableItems from '../withAvailableItems';

export default withAvailableItems(InfusionChoicePaneStore);
